import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loader({ borderRadius }) {
  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 1,
          position: "absolute",
          backgroundColor: "#114C97ca",
          borderRadius: borderRadius ? "30px" : "0px",
        }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
